const isInvalidNumericString = (val) => {
	if (typeof val === 'number') return false

	if (typeof val === 'string') {
		return isNaN(parseFloat(val))
	}

	return true
}

export default isInvalidNumericString
